import { appStore } from '@/stores/app';
import '@/stores/filter';
import Alpine from 'alpinejs';
import { SearchPage } from './search_page';
import { TrackVideoClick } from './track_video_click';

const {
    searchKeyword,
    user: { isLoggedIn },
} = appStore.getGlobalData();

const trackVideoClick = new TrackVideoClick(isLoggedIn, searchKeyword);

Alpine.data('searchPage', () => new SearchPage(trackVideoClick));
